<template>
  <li class="nav-item">
    <a
      class="nav-link"
      :class="{ active: isGroupActive }"
      data-bs-toggle="collapse"
      :href="'#' + collapseId"
      role="button"
      :aria-expanded="isExpanded"
      :aria-controls="collapseId"
    >
      <div
        class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
      >
        <slot name="icon"></slot>
      </div>
      <span class="nav-link-text ms-1">{{ navText }}</span>
    </a>
    <div class="collapse" :class="{ show: isExpanded }" :id="collapseId">
      <ul class="nav ms-4">
        <li v-for="item in items" :key="item.url" class="nav-item">
          <router-link
            :to="item.url"
            class="nav-link"
            :class="{ active: isItemActive(item.url) }"
          >
            {{ item.text }}
          </router-link>
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
export default {
  name: "SidenavCollapse",
  props: {
    collapseId: {
      type: String,
      required: true,
    },
    navText: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    routePrefix: {
      type: String,
      required: true,
    },
  },
  computed: {
    isGroupActive() {
      return this.$route.path.startsWith(this.routePrefix);
    },
    isExpanded() {
      return this.isGroupActive;
    },
  },
  methods: {
    isItemActive(url) {
      return this.$route.path === url || this.$route.path.startsWith(`${url}/`);
    },
  },
};
</script>
